module.exports = __webpack_public_path__ + "images/6b1b8cf65906931021ac59b5fe31c5cd-NTA-logo (1).png";